<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <h1>Produtos</h1>
          <div class="d-flex">
            <div class="switch-container">
              <span class="switch-label mr-1">Destaque</span>
              <toggle-button class="mb-0 mr-3" v-model="form.highlight" :width="80" :height="25" :labels="{ checked: 'ATIVO', unchecked: 'INATIVO'}"/>
            </div>
            <div class="switch-container">
              <span class="switch-label mr-1">Status</span>
              <toggle-button class="mb-0 mr-3" v-model="form.status" :width="80" :height="25" :labels="{ checked: 'ATIVO', unchecked: 'INATIVO'}"/>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-lg-4">
            <b-form-group label="Título*" label-for="title">
              <b-form-input id="title" placeholder="Título" required @input="slugify" v-model="form.title" type="text" @change="title()" :class="{'is-invalid': form.errors.has('title')}">
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-4">
            <b-form-group label="URL Amigável*" label-for="slug">
              <b-form-input id="slug" placeholder="URL Amigável" required v-model="form.slug" @change="userEditedSlug = true" :class="{'is-invalid': form.errors.has('slug')}">
              </b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-4">
            <b-form-group label="Código Quiver" label-for="reference">
              <b-form-input id="reference" placeholder="Código no Quiver" v-model="form.reference" type="text" :class="{'is-invalid': form.errors.has('reference')}">
              </b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  import Uploader from '../../ui/Uploader.vue'
  import slugify from 'slugify'
  import {slugifyOptions} from '@/plugins'
  import { get } from 'lodash'

  export default {
    name: 'Product',
    props: {
      form: {
        type: [Object],
        required: true
      },
      submitted: {
        type: Boolean,
        default: false
      },
      instance: {
        type: Object,
        default () {
          return {
            media: []
          }
        }
      },
      http: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        empty: {
          title: '',
          slug: '',
          reference: '',
          status: true,
          highlight: false
        }
      }
    },

    components: {
      Uploader
    },

    methods: {
      slugify () {
        const self = this

        self.show = false
        self.form.slug = slugify(self.form.title, slugifyOptions)
        self.$nextTick(() => {
          self.show = true
        })
      },

      updateForm (path, value) {
        this.form[path] = value.id
      },

      title () {
        this.$forceUpdate()
      }
    },

    computed: {
      friendlyUrls () {
        return this.instance ? get(this.instance, 'friendly_urls', []) : []
      },

      mediaUrl () {
        return this.http.routes.uploadMedia(this.instance.id)
      }
    },

    created () {
      const self = this

      self.form.withData(self.instance.id ? self.instance : self.empty)
        .setInitialValues(self.instance.id ? self.instance : self.empty)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/forms/Rte/Product.vue